<mat-icon (click)="onCopy()" [cdkCopyToClipboard]="value | laSeparator: '; '" [ngClass]="{ copied: status() }">{{
  status() ? 'done' : 'content_copy'
}}</mat-icon>
